import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

import { Helmet } from 'react-helmet';

import { useForm } from 'react-hook-form';

import { toast } from 'react-toastify';

import Swal from 'sweetalert2';

import { signInRequest } from '~/store/modules/auth/actions';

import LogoQualiss from '~/assets/img/brand/qualiss_logo.PNG';

import { BoxAuth, PageTitle, Left, Right, BoxLabel, Label } from './style';

import Breadcumbs from '~/components/Breadcumbs';

export default function SignIn() {
  const { register, handleSubmit, errors, formState } = useForm();
  const dispath = useDispatch();
  const loading = useSelector(state => state.auth.loading);

  const [authError, setAuthError] = useState(false);

  const [cpfError, setCpfError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  useEffect(() => {}, []);

  useEffect(() => {
    if (authError) {
      setTimeout(() => {
        setAuthError(false);
      }, 5000);
    }
  }, [authError]);

  useEffect(() => {
    if (cpfError) {
      setTimeout(() => {
        setCpfError(false);
      }, 5000);
    }
  }, [cpfError]);

  useEffect(() => {
    if (passwordError) {
      setTimeout(() => {
        setPasswordError(false);
      }, 5000);
    }
  }, [passwordError]);

  const onSubmit = ({ cpf, password }) => {
    if (!cpf && !password) {
      toast.error('Todos os campos são de preenchimento obrigatório', {
        autoClose: 5000,
      });
      setAuthError(true);
      return;
    }
    if (!cpf) {
      toast.error('O CPF é obrigatório.', { autoClose: false });
      setCpfError(true);
      return;
    }

    if (!password) {
      toast.error('A senha é obrigatória.', { autoClose: false });
      setPasswordError(true);
      return;
    }

    sessionStorage.removeItem('cpf');
    sessionStorage.setItem('cpf', cpf);
    dispath(signInRequest(String(cpf).trim(), String(password).trim()));
  };

  return (
    <>
      <Helmet>
        <title>SIHOSP - Sistema de Indicadores Hospitalares</title>
      </Helmet>
      <Breadcumbs path="/" pathTitle="" />
      <PageTitle>
        <span>Fazer login </span>
      </PageTitle>
      <BoxAuth>
        <Left>
          <h4>
            Para acessar o <strong>Sistema de Indicadores</strong>,<br />
            preencha os campos abaixo:
          </h4>

          <form onSubmit={handleSubmit(onSubmit)}>
            <BoxLabel>
              <Label>CPF:</Label>
              <span
                className="notice"
                style={{ color: authError || cpfError ? '#cc0000' : null }}
              >
                *Preenchimento obrigatório
              </span>
            </BoxLabel>

            <input
              name="cpf"
              ref={register({
                pattern: /^\d{11}$/,
                min: 11,
                max: 11,
              })}
              id="cpf"
              style={{ borderColor: authError || cpfError ? '#cc0000' : null }}
            />

            {errors.cpf ? (
              <span>CPF é obritagório e deve ter 11 caracteres.</span>
            ) : (
              <span className="noticeInfo">
                (Somente os números, sem pontos)
              </span>
            )}

            <BoxLabel>
              <Label>Senha:</Label>
              <span
                className="notice"
                style={{ color: authError || passwordError ? '#cc0000' : null }}
              >
                *Preenchimento obrigatório
              </span>
            </BoxLabel>

            <input
              name="password"
              id="password"
              type="password"
              ref={register({})}
              style={{
                borderColor: authError || passwordError ? '#cc0000' : null,
              }}
            />

            {errors.password ? (
              <span>A senha é obrigatória.</span>
            ) : (
              <span className="noticeInfo">
                (A senha deve ter no mínimo 8 (oito) caracteres, contendo letras
                maiúsculas, minúsculas, números de 0 a 9 e caracteres especiais)
              </span>
            )}

            <div className="ButtonBox">
              <button type="submit">
                {loading ? 'Carregando...' : 'Entrar'}
              </button>
              <Link to="/esqueceu-senha">Esqueceu sua senha?</Link>
            </div>
          </form>
        </Left>

        <Right>
          <img src={LogoQualiss} alt="LogoConsorcioIndicadores" />
        </Right>
      </BoxAuth>
    </>
  );
}
